import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69987c1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "zone-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "zone-content"
}
const _hoisted_3 = {
  key: 0,
  class: "zone-card"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "active" }, "星投量化圈子")
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "circle-list" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "circle-header" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "vip-badge"
}
const _hoisted_12 = {
  key: 1,
  class: "circle-content"
}
const _hoisted_13 = ["onMouseenter", "onMouseleave"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  class: "zone-card"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "星投量化直播", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "live-grid" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "live-badge" }
const _hoisted_24 = {
  key: 0,
  class: "vip-badge"
}
const _hoisted_25 = { class: "live-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StarTabBar = _resolveComponent("StarTabBar")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_StarCircleMessage = _resolveComponent("StarCircleMessage")!
  const _component_StarNoData = _resolveComponent("StarNoData")!
  const _component_StarXpGate = _resolveComponent("StarXpGate")!

  return (_openBlock(), _createBlock(_component_StarXpGate, { na: "starZone" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["zone-page", { 'is-light': _ctx.isLight }]),
        style: _normalizeStyle({ background: _ctx.colors.bg })
      }, [
        _createVNode(_component_StarTabBar, {
          modelValue: _ctx.activeTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
        }, null, 8, ["modelValue"]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_a_spin, { tip: "加载中..." })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showCircles)
                ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "card-header",
                      style: _normalizeStyle(_ctx.headerStyle)
                    }, _hoisted_5, 4),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.circles, (item, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.courseSimpleDTO?.courseNo || idx,
                            class: "circle-item",
                            onClick: ($event: any) => (_ctx.openCircle(item))
                          }, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("img", {
                                class: "circle-avatar",
                                src: item.logo || item.image || _ctx.defaultImg,
                                alt: ""
                              }, null, 8, _hoisted_10),
                              _createElementVNode("div", {
                                class: "circle-name",
                                style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.getCircleName(item)) + " ", 1),
                                (item.hasPermission)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "VIP"))
                                  : _createCommentVNode("", true)
                              ], 4),
                              _createElementVNode("div", {
                                class: "circle-teacher",
                                style: _normalizeStyle({ color: _ctx.colors.textMuted })
                              }, _toDisplayString(item.courseSimpleDTO?.mainTeacherName || ''), 5)
                            ]),
                            (_ctx.getCircleIntro(item))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "circle-intro",
                                  style: _normalizeStyle(_ctx.circleIntroStyle)
                                }, _toDisplayString(_ctx.getCircleIntro(item)), 5))
                              : _createCommentVNode("", true),
                            (_ctx.getCirclePoints(item).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("div", {
                                    class: "circle-featured",
                                    onMouseenter: ($event: any) => (_ctx.onCircleScrollEnter(idx, item)),
                                    onMouseleave: ($event: any) => (_ctx.onCircleScrollLeave(idx))
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["circle-featured-wrapper", _ctx.getFeaturedWrapperClass(idx, item)])
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCirclePoints(item), (point, pIdx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: pIdx,
                                          class: "circle-featured-item"
                                        }, [
                                          _createElementVNode("img", {
                                            class: "circle-msg-avatar",
                                            src: point.photoUrl || _ctx.defaultImg,
                                            alt: ""
                                          }, null, 8, _hoisted_14),
                                          _createElementVNode("div", {
                                            class: "circle-msg-bubble",
                                            style: _normalizeStyle(_ctx.circleMsgBubbleStyle)
                                          }, [
                                            _createVNode(_component_StarCircleMessage, { message: point }, null, 8, ["message"])
                                          ], 4)
                                        ]))
                                      }), 128)),
                                      (_ctx.getCirclePoints(item).length >= 3)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getCirclePoints(item), (point, pIdx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: `dup-${pIdx}`,
                                              class: "circle-featured-item"
                                            }, [
                                              _createElementVNode("img", {
                                                class: "circle-msg-avatar",
                                                src: point.photoUrl || _ctx.defaultImg,
                                                alt: ""
                                              }, null, 8, _hoisted_15),
                                              _createElementVNode("div", {
                                                class: "circle-msg-bubble",
                                                style: _normalizeStyle(_ctx.circleMsgBubbleStyle)
                                              }, [
                                                _createVNode(_component_StarCircleMessage, { message: point }, null, 8, ["message"])
                                              ], 4)
                                            ]))
                                          }), 128))
                                        : _createCommentVNode("", true)
                                    ], 2)
                                  ], 40, _hoisted_13)
                                ]))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_8))
                        }), 128))
                      ]),
                      (!_ctx.circles.length)
                        ? (_openBlock(), _createBlock(_component_StarNoData, {
                            key: 0,
                            isDark: _ctx.isDark
                          }, null, 8, ["isDark"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showVideos)
                ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                    _createElementVNode("div", {
                      class: "card-header",
                      style: _normalizeStyle(_ctx.headerStyle)
                    }, _hoisted_18, 4),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (item, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.courseInfo?.courseNo || idx,
                            class: "live-item",
                            onClick: ($event: any) => (_ctx.openVideo(item))
                          }, [
                            _createElementVNode("img", {
                              class: "live-img",
                              src: _ctx.getVideoCover(item) || _ctx.defaultImg,
                              alt: ""
                            }, null, 8, _hoisted_22),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.getLiveStatusText(item)), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "live-info",
                              style: _normalizeStyle(_ctx.liveInfoStyle)
                            }, [
                              _createElementVNode("div", {
                                class: "live-name",
                                style: _normalizeStyle({ color: _ctx.colors.textPrimary })
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.getVideoTitle(item)) + " ", 1),
                                (item.hasPermission)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "VIP"))
                                  : _createCommentVNode("", true)
                              ], 4),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("span", {
                                  class: "course-name",
                                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                                }, _toDisplayString(_ctx.getVideoTeacherName(item)), 5),
                                _createElementVNode("span", {
                                  class: "live-time",
                                  style: _normalizeStyle({ color: _ctx.colors.textMuted })
                                }, _toDisplayString(_ctx.formatStarTime(_ctx.getVideoTime(item))), 5)
                              ])
                            ], 4)
                          ], 8, _hoisted_21))
                        }), 128))
                      ]),
                      (!_ctx.videos.length)
                        ? (_openBlock(), _createBlock(_component_StarNoData, {
                            key: 0,
                            isDark: _ctx.isDark
                          }, null, 8, ["isDark"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showCircles && !_ctx.showVideos)
                ? (_openBlock(), _createBlock(_component_StarNoData, {
                    key: 2,
                    isDark: _ctx.isDark
                  }, null, 8, ["isDark"]))
                : _createCommentVNode("", true)
            ]))
      ], 6)
    ]),
    _: 1
  }))
}